/**
 * Бренд в store-сборке — OneBilim Academy (ребрендинг 1.1.1, решение владельца 04–05.10.2026; до этого D76 —
 * «1 BILIM ACADEMY» в сборках 61 и 102).
 *
 * Два имени, и путать их нельзя:
 * - `APP_BRAND` — «OneBilim Academy»: так приложение называет себя внутри — экран входа, шапки, документы;
 * - `APP_DEVICE_NAME` — «OneBilim Academy App»: имя под иконкой (`CFBundleDisplayName`, `appName`) и в App Store.
 *   Его же ученик видит в «Настройках» телефона, поэтому подсказки «Настройки → <имя> → Микрофон / Уведомления»
 *   подставляют именно его. Сторож сверяет его с Info.plist и InfoPlist.strings — `src/app/appBrand.test.ts`.
 * Сайт в браузере остаётся onebilim — его не трогаем. Домен academy.onebilim.kz, почта поддержки
 * (1bilimcompany.com) и метка UA `1BilimAcademy` — не бренд, они остаются везде.
 *
 * ⚠️ ПОЧЕМУ РЕЖИМ СБОРКИ, А НЕ isStoreBuild(). `isStoreBuild()` решает во время работы, и тогда обе строки —
 * «Onebilim» для сайта и «OneBilim Academy» для приложения — лежат в одном бандле, и сайт получил бы строки
 * приложения, а приложение — строки сайта. `import.meta.env.MODE` Vite подставляет при сборке: в
 * `vite build --mode mobile` ветка сайта выпадает из dist-mobile целиком. Сборка `dist-mobile` едет только в приложение из магазина.
 *
 * Пишите на месте использования `IS_APP_BUILD ? APP_BRAND : '<как на сайте>'` — одной строкой-тернарником:
 * так минификатор гарантированно выбрасывает ветку сайта. Сторож — `src/app/appBrand.test.ts`.
 *
 * С 26.09.2026 тем же флагом вырезается всё, чего в приложении нет (D75, вариант Б): гость, сторис, лендинг с
 * заявкой, тарифы, чат и прочие разделы вне меню, знак на видео. Режим `mobile-staging` — тот же код приложения
 * с API стенда, для симулятора (vite.config.ts, `isAppMode`); в магазин едет только `mobile`.
 */
export const IS_APP_BUILD = import.meta.env.MODE === 'mobile' || import.meta.env.MODE === 'mobile-staging';

export const APP_BRAND = 'OneBilim Academy';

export const APP_DEVICE_NAME = 'OneBilim Academy App';
